import { render } from "./PageTopSection.vue?vue&type=template&id=a2d5948e"
import script from "./PageTopSection.vue?vue&type=script&lang=js"
export * from "./PageTopSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__